import { render, staticRenderFns } from "./loaders.vue?vue&type=template&id=486598a0"
import script from "./loaders.vue?vue&type=script&lang=js"
export * from "./loaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports